export class Sport1Analytics {
    sendEvent(category,action,label) {
        window.dataLayer.push({
            'event': 'click',
            'event_category': category,
            'event_action': action,
            'event_label': label
        });
    }
}